var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.354 17.959V17.9458C17.3513 17.9502 17.3476 17.9546 17.3452 17.959H17.354Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1486_2236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3275 10.2173H7.31998C7.23088 10.2173 7.15869 10.2895 7.15869 10.3786V16.8279C7.15869 16.917 7.23088 16.9892 7.31998 16.9892H9.3275C9.41659 16.9892 9.48879 16.917 9.48879 16.8279V10.3786C9.48879 10.2895 9.41659 10.2173 9.3275 10.2173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32471 7.01123C7.59426 7.01123 7 7.60484 7 8.33449C7 9.06446 7.59426 9.65829 8.32471 9.65829C9.05458 9.65829 9.64835 9.06442 9.64835 8.33449C9.64839 7.60484 9.05458 7.01123 8.32471 7.01123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4338 10.0571C13.6275 10.0571 13.0314 10.4037 12.6699 10.7976V10.3787C12.6699 10.2896 12.5977 10.2174 12.5086 10.2174H10.5861C10.497 10.2174 10.4248 10.2896 10.4248 10.3787V16.828C10.4248 16.9171 10.497 16.9893 10.5861 16.9893H12.5892C12.6783 16.9893 12.7505 16.9171 12.7505 16.828V13.6371C12.7505 12.5618 13.0426 12.1429 13.7921 12.1429C14.6085 12.1429 14.6733 12.8145 14.6733 13.6924V16.828C14.6733 16.9171 14.7455 16.9893 14.8346 16.9893H16.8385C16.9276 16.9893 16.9998 16.9171 16.9998 16.828V13.2905C16.9998 11.6916 16.6949 10.0571 14.4338 10.0571Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1486_2236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.428201c103febe2a4f9603478ebb7279.svg";
export { ForwardRef as ReactComponent };